interface INumberField {
  disabled: boolean;
  validity: { badInput: boolean };
}

/** The first enabled number field whose text the browser could not parse. */
export function firstBadNumberInput<T extends INumberField>(
  fields: Iterable<T>
): T | null {
  for (const field of fields)
    if (!field.disabled && field.validity.badInput) return field;
  return null;
}

/**
 * Forms that accept values the browser's own constraints reject (a turno
 * ending 23:59 against `step=900`) run with `novalidate`, so a number field
 * left with text the browser cannot parse (`validity.badInput`, e.g. "1e")
 * reads as empty and would save as "no limit". Surfaces the first such field
 * with the native message and tells the caller to stop.
 */
export function reportBadNumberInput(
  root: HTMLElement | null | undefined
): boolean {
  const field = firstBadNumberInput(
    root?.querySelectorAll<HTMLInputElement>('input[type="number"]') ?? []
  );
  if (!field) return false;
  field.scrollIntoView({ block: 'center', behavior: 'smooth' });
  field.reportValidity();
  return true;
}
